import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmDialogComponent implements OnInit {
    title = '';
    content = '';
    confirm = '';
    dismiss = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) private data: any,
        private dialogRef: MatDialogRef<ConfirmDialogComponent>
    ) {
        this.dialogRef.disableClose = true;
        this.title = data.title;
        this.content = data.content;
        this.confirm = data.confirm ? data.confirm : 'Sim';
        this.dismiss = data.dismiss ? data.dismiss : 'Não';
    }

    ngOnInit() {}
}
